module.exports = __webpack_public_path__ + "img/Ind.368bda50.jpg";